import React, { Component } from "react";
import { toast } from "react-toastify";
import PageLoading from "./common/pageLoading";
import { Pagination, Form } from "react-bootstrap";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { StyledTableCell, StyledTableRow } from "../services/tableStyles";
import { getIpV4AddressesByPoolId, getAddressesCount } from "../services/ipv4PoolService";

class IpV4Addresses extends Component {
  state = {
    addresses: [],
    totalAddresses: "",
    searchQuery: "",
    pageSize: 10,
    currentPage: 1,
    loading: true,
  };

  async populateAddresses(currentPage, pageSize, searchQuery) {
    const poolId = this.props.match.params.id;
    try {
      const { data: addresses } = await getIpV4AddressesByPoolId(poolId, currentPage, pageSize, searchQuery);
      const { data: totalAddresses } = await getAddressesCount(poolId, searchQuery);
      this.setState({ addresses, totalAddresses });
    } catch (ex) {
      if (ex.response && ex.response.status >= 400 && ex.response.status < 500) {
        toast(ex.response.data);
      }
    }
    this.setState({ loading: false });
  }

  async componentDidMount() {
    const { currentPage, pageSize, searchQuery } = this.state;
    await this.populateAddresses(currentPage, pageSize, searchQuery);
  }

  handleSearch = async (e) => {
    this.setState({ loading: true });
    const { currentPage, pageSize } = this.state;
    const value = e.currentTarget.value;
    this.setState({ searchQuery: value, currentPage: 1 });
    await this.populateAddresses(currentPage, pageSize, value);
  };

  handlePageChange = async (direction) => {
    this.setState({ loading: true });
    const { currentPage, pageSize, searchQuery } = this.state;
    const newPage = direction === "next" ? currentPage + 1 : currentPage - 1;

    await this.populateAddresses(newPage, pageSize, searchQuery);
    this.setState({ currentPage: newPage });
  };

  render() {
    const { addresses, totalAddresses, searchQuery, currentPage, pageSize, loading } = this.state;

    const pagesCount = Math.ceil(totalAddresses / pageSize);

    return (
      <React.Fragment>
        <Form className="mt-4 mb-5">
          <Form.Group controlId="searchQuery">
            <Form.Control
              type="text"
              name="searchQuery"
              value={searchQuery}
              autoFocus
              autoComplete="off"
              onChange={this.handleSearch}
              placeholder="Search IPv4 Addresses By Address and Equipment Serial Number..."
            />
          </Form.Group>
        </Form>

        {loading && <PageLoading loading={loading} />}
        {!loading && addresses.length === 0 && <span>No Addresses to Display</span>}
        {!loading && addresses.length > 0 && (
          <TableContainer component={Paper}>
            <Table aria-label="customized table">
              <TableHead>
                <TableRow>
                  <StyledTableCell>Address</StyledTableCell>
                  <StyledTableCell>Equipment S/N</StyledTableCell>
                  <StyledTableCell>Customer</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {addresses.map((address) => (
                  <StyledTableRow key={address._id}>
                    <StyledTableCell component="th" scope="row">
                      <kbd>{address.address}</kbd>
                    </StyledTableCell>
                    <StyledTableCell>{address.equipment}</StyledTableCell>
                    <StyledTableCell>{address.user}</StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}

        {!loading && pagesCount > 0 && (
          <Pagination className="mt-5">
            {pagesCount > 1 && (
              <React.Fragment>
                {currentPage !== 1 && (
                  <Pagination.Item onClick={() => this.handlePageChange("prev")}>Previous</Pagination.Item>
                )}
                <Pagination.Item>
                  Page {currentPage} of {pagesCount}
                </Pagination.Item>
                {currentPage !== pagesCount && (
                  <Pagination.Item onClick={() => this.handlePageChange("next")}>Next</Pagination.Item>
                )}
              </React.Fragment>
            )}
          </Pagination>
        )}
      </React.Fragment>
    );
  }
}

export default IpV4Addresses;
